import React from "react";
import AutocompleteField from "./AutocompleteField";
import { useProject } from "../../../contexts/project";
import { getCostCenterValue } from "../../../views/capture/FieldsIdentifiers";

export default function CostCenterSelectField(props) {
  const currentProject = useProject();
  const { costCenter } = props.entity;

  const costCenterOptions = (currentProject?.costCenters || [])
    .map(cc => [parseInt(cc.id), getCostCenterValue(cc)])
    .sort((a, b) => a[1].localeCompare(b[1]));

  const displayValue = costCenter?.id
    ? getCostCenterValue(
        currentProject?.costCenters?.find(cc => parseInt(cc.id) === parseInt(costCenter.id))
      )
    : "";

  const handleChange = selectedLabel => {
    const match = costCenterOptions.find(([, label]) => label === selectedLabel);
    if (!match) return;
    const costCenterId = match[0];
    const values = {
      costCenter: {
        id: costCenterId,
        costCenterName: match[1],
        costCenterId,
      },
    };
    props.onChange(props.entity.id, values, { skipMutation: true });
    props.onChange(props.entity.id, { costCenterId });
  };

  return (
    <AutocompleteField
      {...props}
      value={displayValue}
      options={costCenterOptions}
      onSubmit={handleChange}
    />
  );
}
